import { useCallback, useRef, useState, type ComponentProps } from 'react';
import { ChannelFilterInput } from './ChannelFilterInput';
import { ChannelList } from './ChannelList';
import { useChatSidebarShortcut } from '../hooks/useChatSidebarShortcut';

type ChannelListProps = Omit<ComponentProps<typeof ChannelList>, 'filterQuery'>;

/**
 * The chat list with its type-to-filter box above it. Owns the filter text
 * so typing re-renders only this sidebar, never the page and the message pane
 * beside it. Picking a conversation clears the filter — it was a means of
 * finding that conversation, not a view to keep. Cmd/Ctrl+K focuses the box.
 */
export function FilterableChannelList({ onSelectChannel, ...listProps }: ChannelListProps) {
  const [filterQuery, setFilterQuery] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);
  useChatSidebarShortcut(inputRef);

  const handleSelectChannel = useCallback(
    (channelId: string) => {
      setFilterQuery('');
      onSelectChannel(channelId);
    },
    [onSelectChannel],
  );

  return (
    <>
      <ChannelFilterInput value={filterQuery} onChange={setFilterQuery} inputRef={inputRef} />
      <ChannelList {...listProps} onSelectChannel={handleSelectChannel} filterQuery={filterQuery} />
    </>
  );
}
